import { Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GetCompaniesBySearchParams } from '../../../global/adapters/crpAPI';
import StepUseCase from '../../../global/components/Stepper/StepUseCase';
import CompaniesSearchStep from './CompaniesSearchStep';
import { FormikErrors } from 'formik';

type Props = {
  isFetching?: boolean;
  resetForm: VoidFunction;
  submitForm: VoidFunction;
  values: GetCompaniesBySearchParams;
  errors: FormikErrors<GetCompaniesBySearchParams>;
};

const StepperSearchCompanies = ({ isFetching, resetForm, submitForm, values, errors }: Props) => {
  const { t } = useTranslation(['common', 'useCase']);
  const resetFormAndValues = () => {
    resetForm();
  };
  const { identificationType, identificationCode } = values;
  const searchAvailable = !!identificationType && !!identificationCode;

  return (
    <Paper sx={{ p: 2, minWidth: 0, overflow: 'visible' }}>
      <StepUseCase
        activeStep={0}
        steps={[
          {
            stepTitle: t('common:general.search'),
            stepFlavorText: t('useCase:entities.companiesSearchFlavorText'),
            backCallBack: resetFormAndValues,
            backCustomText: t('common:general.reset'),
            nextCallBack: submitForm,
            nextCustomText: isFetching
              ? t('useCase:entities.loadingCompanies')
              : t('useCase:entities.searchCompanies'),
            nextIsLoading: isFetching,
            content: <CompaniesSearchStep />,
            disableNext: !searchAvailable,
          },
        ]}
      />
    </Paper>
  );
};
export default StepperSearchCompanies;
